// extracted by mini-css-extract-plugin
module.exports = {"trendIndicator":"styles_trendIndicator__11Odl","trendIndicatorArrow":"styles_trendIndicatorArrow__3IM_V","positive":"styles_positive__1q0yc","negative":"styles_negative__11H7J"};